<div class="funnel-header">
  <div class="logo-section">
    <img src="assets/Teleauro.png" alt="Teleauora" class="logo-img" />
  </div>
  <div class="step-indicator">
    <span class="step-text">Step {{ currentStep }} of 5</span>
  </div>
</div>
